import { Avatar, Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { firestore } from '../../../../contexts/FirebaseContext';

function UserBasicInfo({ user_id, showImg = false }) {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getUser() {
      setLoading(true);
      await firestore
        .collection('users')
        .doc(user_id)
        .get()
        .then((res) => {
          setUserData(res.data());
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error.response);
        });
    }

    if (!user_id) return;

    // eslint-disable-next-line consistent-return
    return getUser();
  }, [user_id]);
  return (
    <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      {showImg && <Avatar alt={userData?.displayName} src={userData?.photoURL} />}
      {user_id ? (
        <Typography fontSize="15px">{userData?.displayName}</Typography>
      ) : (
        <Typography fontSize="15px">-</Typography>
      )}
    </Box>
  );
}

export default UserBasicInfo;
